import '../Client.scss';

import { ArrowForward } from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
//import { ArrowBack } from '@mui/icons-material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { Alert, Button, Tooltip } from '@mui/material';
import { FormControl, FormControlLabel, Radio,RadioGroup} from '@mui/material';
//import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { buttonStyles, buttonStylesBlue } from '../../../../Components/docsAdministrative/JsObjectStyles';
import { TextFieldComponent } from '../../../../Components/shared/ReusableSmallComponents';
import SearchCity from '../../../../Components/shared/SearchCity';
import { BgIconEntreprise, DrawStep3ClientIcone } from '../../../../data/SVGs.js';
import useAuth from '../../../../hooks/useAuth';
import useAxiosPrivate from '../../../../hooks/useAxiosPrivate';
import useFormValidation from '../../../../hooks/useFormValidation';
import usePostRequest from '../../../../hooks/usePostRequest';
import useRole from '../../../../hooks/useRole';
import useUtilities from '../../../../hooks/useUtilities';
import useWindowSize from '../../../../hooks/useWindowSize';
import UploadImage from '../../../../Utils/fileUpload/UploadImage';
import { CompareTwoString, DateValidationEntrprise, getUrlForAnImage, IMAGE_CONTEXT_ENUM, isANewUserWithoutAnyRole, isUrlFromCompleterProfile } from '../../../../Utils/utils';

function NewCompany({action}) {
    NewCompany.propTypes = {
        action: PropTypes.any,
    };
    const {postData} = usePostRequest();
    const {setBackdropOpen, setShowErrors, setErrors}=useUtilities();
    const { auth, setAuth } = useAuth();
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const { state } = useLocation();
    const {device}=useWindowSize();
    const [image1, setImage1] = useState(null);
    const [nom, setNom] = useState('');
    const [adresse, setAdress] = useState('');
    const [siret, setSiret] = useState('');
    const [noTVA, setNoTVA] = useState('');
    const [localisation, setLocalisation] = useState();
    const [codePostal, setCodePostal] = useState('');
    const {pathname} = useLocation();
    const [dateValidation, setDateValidation] = useState(null);
    const [isEntrepriseNonValidee, setIsEntrepriseNonValidee] = useState(false);
    const [isSignataire, setIsSignataire] = useState('');

    const [logo, setLogo] = useState('');
    const [unauthorizedModif,setUnauthorizedModif]=useState(true);
    const role=useRole();
    let param = useParams();
    const [dataClient, setdataClient] = useState({});
    const [checkUpdateValue,setCheckUpdateValue]=useState(true);
    const { i18n } = useTranslation();
    const [isValid] = useFormValidation([
        { name: 'nom', value: nom },
        { name: 'adresse', value: adresse },
        { name: 'localisation', value: localisation },
        { name: 'codePostal', value: codePostal },
        { name: 'siret', value: siret },
        { name: 'noTVA', value: noTVA },
    ]);
    const handleSelect = (event) => {
        if(!CompareTwoString(event.target.value,dataClient?.signataire?.isSignataireDiff)){
            setCheckUpdateValue(false);
        }
        setIsSignataire(event.target.value); // Extract the value from the event object
    };
    const getClientbyId = async () => {
        if(role=='admin')
        {
            try {
                setBackdropOpen(true);
                let endpoint = pathname.includes('gestionEsn') ? '/users/getEsnById/':'/users/getClientById/';
                const response = await axiosPrivate.get(endpoint+(param.ClientId ?? param.EsnId));
                setdataClient(response?.data);
                let endpoint1 = pathname.includes('gestionEsn') ? '/users/getDocsEsnById':'/users/getDocsClientById';
                const response2 = await axiosPrivate.get(`${endpoint1}/${(param.ClientId ?? param.EsnId)}`);
                setDateValidation(DateValidationEntrprise(response2?.data?.docsAdministratifs)?.dateValidation);
                if(!DateValidationEntrprise(response2?.data)?.dateValidation){
                    setIsEntrepriseNonValidee(true);
                }
                setBackdropOpen(false);
            } catch (error) {
                console.log(error);
                setBackdropOpen(false);
            }
        }
        if(role=='client'){
            try {
                setBackdropOpen(true);
                const response = await axiosPrivate.get('/client/getMyInfos');
                if(response?.data?.collaborator?.roles['Admin']==1 || response?.data?.collaborator?.roles['littleAdmin']==1 || isANewUserWithoutAnyRole(response?.data?.collaborator?.roles) ){
                    setUnauthorizedModif(false);
                }
                setdataClient(response?.data?.collaborator?.companyDataId);
                const response2 = await axiosPrivate.get('docAdministratif/getMyDocsAdministratifs');
                console.log('response2?.data',response2?.data);
                if(DateValidationEntrprise(response2?.data)?.statut!='expire')
                    setDateValidation(DateValidationEntrprise(response2?.data)?.dateValidation);
                if(!DateValidationEntrprise(response2?.data)?.dateValidation){
                    setIsEntrepriseNonValidee(true);
                }
                setBackdropOpen(false);
            } catch (error) {
                console.log(error);
                setBackdropOpen(false);
            }
        }
        if(role=='esn'){
            try {
                setBackdropOpen(true);
                const response = await axiosPrivate.get('/esn/getMyInfos');
                if(response?.data?.collaboratorEsn?.roles['Admin']==1 || response?.data?.collaboratorEsn?.roles['littleAdmin']==1 || isANewUserWithoutAnyRole(response?.data?.collaboratorEsn?.roles) ){
                    setUnauthorizedModif(false);
                }
                setdataClient(response?.data?.collaboratorEsn?.esnId);
                const response2 = await axiosPrivate.get('docAdministratif/getMyDocsAdministratifs');
                console.log('response2?.data',response2?.data);
                if(DateValidationEntrprise(response2?.data)?.statut!='expire')
                    setDateValidation(DateValidationEntrprise(response2?.data)?.dateValidation);
                if(!DateValidationEntrprise(response2?.data)?.dateValidation){
                    setIsEntrepriseNonValidee(true);
                }
                setBackdropOpen(false);
            } catch (error) {
                console.log(error);
                setBackdropOpen(false);
            }
        }
    };

    useEffect(() => {
        getClientbyId();
    }, [role]);

    //! @aida I prefer to have an OPEN_CLOSED approach for this setCheckUpdateValue instead of doing it inside onclick inside the jsx .. (it s a modif)
    //useEffect(() => {
    //    setCheckUpdateValue(false);
    //}, [localisation,image1]);

    const setInitialValue=(data)=>{
        setNom(data?.profileEntreprise?.nom);
        //var tempCity=data?.profileEntreprise?.adress.split(',');
        setLocalisation(data?.profileEntreprise?.localisation);
        setAdress(data?.profileEntreprise?.address);
        setSiret(data?.profileEntreprise?.siret);
        setNoTVA(data?.profileEntreprise?.noTVA);
        setLogo(data?.profileEntreprise?.logo);
        setIsSignataire(data?.signataire?.isSignataireDiff == true?'true':'false');
        setCodePostal(data?.profileEntreprise?.codePostal);
        setCheckUpdateValue(true);
        setBackdropOpen(false);
    };

    useEffect(()=>{
        if(dataClient)
            setInitialValue(dataClient);
    }, [dataClient]);

    const navigateToNextStep = () => {
        if(action=='create'){
            if (isUrlFromCompleterProfile(pathname)){
                if(auth.completeStep < 4){
                    // ! must be another statut, maybe I need to change completely the counting logic since I need another state: maybe step=6 will be the final one
                    // * Update the complete step to 4
                    setAuth({ ...auth, completeStep: 4 });
                }
                navigate(`/${role}/completeProfile/step4`, {state: {  state, },});
            }
        }
    };

    const updateProData = async (URL) => {
        console.log('URL \n\n', URL);
        const formData = new FormData();
        try {
            // if(action=='visualise')
            //    { setBackdropOpen(true); }
            // formData.append('kbis', kbis);
            formData.append('siret', siret);
            formData.append('address', adresse);
            formData.append('noTVA', noTVA);
            if(image1)
                formData.append('logo', URL);
            else
                formData.append('logo', logo);
            formData.append('nom', nom);
            formData.append('codePostal', codePostal);
            formData.append('localisation', localisation);
            formData.append('isSignataireDiff', isSignataire=='true'?true:false);
            if(action=='create')
            {
                formData.append('isFromAccountCompletion', isUrlFromCompleterProfile(pathname));
            }
            const response1 = await postData({url:`/${role}/createCompany`,payload :formData});
            const responseData1 = await response1.data;
            console.log('submitresumeBackend', responseData1);
            navigateToNextStep();
        } catch (error) {
            console.log(error.response?.status);
        }
    };

    async function onSubmit() {
        if (image1) {
            const imageUrl = await getUrlForAnImage(image1, axiosPrivate, IMAGE_CONTEXT_ENUM.clientlogo);
            updateProData(imageUrl);
        }
        // if there is no uploaded image
        else {
            console.log('image1');
            updateProData(null);
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };

    console.log('authorizedModifyInfo',(role=='admin'||(role=='client' && unauthorizedModif)));
    return (
        <form className='Frame0DonneesPersonnelsExpert'>
            <div style={{display:'flex',flexDirection:'row',gap:'8px'}}>
                <h3 className="InfoEntr">{i18n.t('Informations de l\'entreprise')}</h3>
                {(!isUrlFromCompleterProfile(pathname) && dateValidation && dateValidation !=null) && <p style={{paddingTop:'10px'}}><Tooltip title={i18n.t('Entreprise validée par High Tech Hires le ')+dateValidation}><InfoOutlinedIcon /></Tooltip></p>}
            </div>
            {(action =='visualise' ||action =='admin') &&
                    <>
                        {!dateValidation && isEntrepriseNonValidee &&
                            <div><Alert severity="error">{i18n.t('Entreprise pas encore validée par High Tech Hires')}</Alert></div>
                        }
                    </>
            }
            <div style={{display:'flex',flexDirection:'row',alignSelf:'stretch',justifyContent:'space-between'}}>
                <div style={{display:'flex',flexDirection:'column',gap:'8px',}}>
                    <p className="BoxLogoTitle">{i18n.t('Logo de l\'entreprise')}</p>
                    <UploadImage
                        setImage1={setImage1}
                        image1={image1}
                        imageUrl={logo}
                        setImageUrl={setLogo}
                        check={setCheckUpdateValue}
                        typeTraitement={(((role=='client'||role=='esn') && unauthorizedModif)||role=='admin')? 'readOnly' : ''}
                    />
                </div>
                {device=='desktop' &&
                <div>
                    <DrawStep3ClientIcone />
                    <div style={{ marginTop: '-118px'}}>
                        <BgIconEntreprise />
                    </div>
                </div>
                }
            </div>

            <div className="BoxNewComp">
                <div className="BoxForm">
                    {/* {action =='create' && */}
                    <div className='frame10DonneeFacturation'>
                        <FormControl style={{display:'flex',flexDirection:'row',gap:'16px'}}>
                            <p className='IntitulePoste'>{i18n.t('Etes-vous le signataire légal ? ')}</p>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="client"
                                name="radio-buttons-group"
                                value={isSignataire}
                                onChange={handleSelect}
                                style={{display:'flex',flexDirection:'row',gap:'8px'}}
                            >
                                <FormControlLabel
                                    value='true'
                                    control={<Radio />}
                                    label="Oui"
                                />
                                <FormControlLabel
                                    value='false'
                                    control={<Radio />}
                                    label="Non"
                                />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    {/* } */}
                    <div style={{display:'flex',alignSelf:'stretch',flexDirection:'column',gap:'8px'}}>
                        <p className="BoxLogoTitle">{i18n.t('Nom d\'entrerprise * :')}</p>
                        <TextFieldComponent
                            id="outlined-name"
                            name='nom'
                            //label="Entreprise"
                            value={nom}
                            disabled={(role=='admin'||((role=='client'||role=='esn') && unauthorizedModif)) ? true : false}
                            sx={{
                                '& > :not(style)': {borderRadius: '8px'},
                            }}
                            style={{width:'100%', background: 'white',borderRadius: '8px'}}
                            onChange={(e) => {
                                if(!CompareTwoString(e.target.value,dataClient?.profileEntreprise?.nom)){
                                    setCheckUpdateValue(false);
                                }
                                setNom(e.target.value);
                            }}
                        />
                    </div>
                    <TextFieldComponent
                        id="outlined-name"
                        name="adresse"
                        label={i18n.t('Adresse *')}
                        value={adresse}
                        disabled={(role=='admin'||((role=='client'||role=='esn') && unauthorizedModif)) ? true : false}
                        sx={{
                            '& > :not(style)': {borderRadius: '8px'},
                        }}
                        style={{width:'100%', background: 'white',borderRadius: '8px'}}
                        onChange={(e) => {
                            if(!CompareTwoString(e.target.value,dataClient?.profileEntreprise?.address)){
                                setCheckUpdateValue(false);
                            }
                            setAdress(e.target.value);
                        }}
                    />
                    <div className="SuiteAdresse">
                        <SearchCity
                            name='localisation'
                            city={localisation}
                            label={i18n.t('Ville')}
                            setCity={setLocalisation}
                            width={device=='desktop'?'50%':'100%'}
                            role={(role=='admin'||((role=='client'||role=='esn') && unauthorizedModif)) ? 'visibleOnly' : ''}
                            check={setCheckUpdateValue}
                        />
                        <TextFieldComponent
                            id="outlined-uncontrolled"
                            name='codePostal'
                            label={i18n.t('Code Postal *')}
                            disabled={(role=='admin'||((role=='client'||role=='esn') && unauthorizedModif)) ? true : false}
                            sx={{
                                '& > :not(style)': {borderRadius: '8px'},
                            }}
                            type='number'
                            onKeyDown={handleKeyDown}
                            InputProps={{
                                inputProps: { min: 0,}
                            }}
                            value={codePostal}
                            style={{width:device=='desktop'?'50%':'100%', background: 'white',borderRadius: '8px'}}
                            onChange={(e) => {
                                if(!CompareTwoString(e.target.value,dataClient?.profileEntreprise?.codePostal)){
                                    setCheckUpdateValue(false);
                                }
                                setCodePostal(e.target.value);
                            }}
                        />
                    </div>
                    <div className="SiretBox">
                        <TextFieldComponent
                            id="outlined-name"
                            name='siret'
                            label={i18n.t('Siret *')}
                            disabled={(role=='admin'||((role=='client'||role=='esn') && unauthorizedModif)) ? true : false}
                            sx={{
                                '& > :not(style)': {borderRadius: '8px'},
                            }}
                            value={siret}
                            style={{width:device=='desktop'?'50%':'100%', background: 'white',borderRadius: '8px'}}
                            onChange={(e) => {
                                if(!CompareTwoString(e.target.value,dataClient?.profileEntreprise?.siret)){
                                    setCheckUpdateValue(false);
                                }
                                setSiret(e.target.value);
                            }}
                        />
                        <TextFieldComponent
                            //InputProps={{
                            //    startAdornment: <InputAdornment position="start">
                            //    %
                            //    </InputAdornment>,
                            //    inputProps: { min: 0, max: 100 },
                            //}}
                            disabled={(role=='admin'||((role=='client'||role=='esn') && unauthorizedModif)) ? true : false}
                            name='noTVA'
                            value={noTVA}
                            // type="number"
                            sx={{
                                '& > :not(style)': {borderRadius: '8px'},
                            }}
                            style={{width:device=='desktop'?'50%':'100%', background: 'white',borderRadius: '8px'}}
                            label={i18n.t('Numéro du TVA *')}
                            onChange={(e) => {
                                //var value = e.target.value;
                                //if (value >= 100) value = 100;
                                //if (value < 0) value = 0;
                                if(!CompareTwoString(e.target.value,dataClient?.profileEntreprise?.noTVA)){
                                    setCheckUpdateValue(false);
                                }
                                setNoTVA(e.target.value);
                            }}
                        />
                    </div>
                    {action =='create' &&
                            <div style={{ display: 'flex', flexDirection: device=='desktop'?'row':'column', justifyContent: 'space-between', alignSelf: 'stretch' ,gap:device=='desktop'?'0px':'16px'}}>
                                <Button
                                    variant="outlined"
                                    style={{...buttonStyles(),...{width:device=='desktop' ? 'auto':'100%'}}}
                                    onClick={() => {
                                        navigate('/client');
                                    }}
                                >
                                    {i18n.t('Remplir plus tard')}
                                </Button>
                                <Button
                                    variant="contained"
                                    style={{...buttonStylesBlue(),...{width:device=='desktop' ? 'auto':'100%'}}}
                                    startIcon={<ArrowForward />}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (isValid) {
                                            onSubmit();
                                            setShowErrors(false);
                                            setErrors({});
                                        }
                                        else setShowErrors(true);
                                    }}
                                >
                                    {i18n.t('Valider')}
                                </Button>
                            </div>
                    }
                    {action =='visualise' &&
                            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',justifyContent:'space-between',alignSelf:'stretch',gap:device=='desktop'?'0px':'16px'}}>
                                <Button
                                    variant="text"
                                    style={{...buttonStyles(),...{width:device=='desktop' ? 'auto':'100%',order:device=='desktop' ?'0':'1'}}}
                                    onClick={() => {setInitialValue(dataClient);}}
                                >
                                    {i18n.t('Annuler')}
                                </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    style={{...buttonStylesBlue(checkUpdateValue),...{width:device=='desktop' ? 'auto':'100%',order:device=='desktop' ?'1':'0'}}}
                                    disabled={checkUpdateValue}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (isValid) {
                                            onSubmit();
                                            setCheckUpdateValue(true);
                                            setShowErrors(false);
                                            setErrors({});
                                        }
                                        else setShowErrors(true);
                                    }}
                                    startIcon={<SaveOutlinedIcon />}
                                >
                                    {i18n.t('Sauvegarder')}
                                </Button>
                            </div>
                    }
                </div>
            </div>
        </form>
    );
}

export default NewCompany;
